import React from 'react';
import Grid from '@mui/material/Grid';
import kebabCase from 'lodash/kebabCase';
import Typography from '@mui/material/Typography';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import UpdateIcon from '@mui/icons-material/Update';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ColumnLinks from '../../../components/ColumnLinks';
import BreadcrumbsByLocation from '../../../components/BreadcrumbsByLocation';

import operationsHomePageStyles from './operationsHomePageStyles';

export const columns1 = [
    {
        title: 'Escorted Tours',
        link: '/operations/self-operation-tours',
        body: 'Manage escorted tours and related operational records.',
        // eslint-disable-next-line react/display-name
        icon: (props) => <FontAwesomeIcon {...props} icon={['fa', 'bus']} />,
        notDeveloped: false,
        permissionId: 'setup.escorted_tour:view'
    },
    {
        title: 'Report Reservation to Supplier',
        link: kebabCase('Report Reservation to Supplier'),
        body: 'Centralize and collectively report all reservations not yet reported to suppliers. It is also possible to send reminders to suppliers regarding reservations that have been reported, but have not yet been confirmed.',
        // eslint-disable-next-line react/display-name
        icon: (props) => <FontAwesomeIcon {...props} icon={['fa', 'file-invoice-dollar']} />,
        notDeveloped: true,
        permissionId: 'setup.report_reservation_supplier:view'
    },
    {
        title: 'Update Reservation From Supplier',
        link: kebabCase('Update Reservation From Supplier'),
        body: 'Document suppliers confirmation of reported bookings, update the status of bookings, and report all updates to clients.',
        icon: UpdateIcon,
        notDeveloped: true,
        permissionId: 'setup.update_reservation_supplier:view'
    },
    {
        title: 'Release Allocations',
        link: kebabCase('Release Allocations'),
        body: 'Release hotel allocations back to supplier according to the release terms specified for the product; also, release allocations on specific dates. In addition, concurrently, report allocation bookings that have not yet been reported.',
        // eslint-disable-next-line react/display-name
        icon: (props) => <FontAwesomeIcon {...props} icon={['fa', 'hotel']} />,
        notDeveloped: true
    },
    {
        title: 'Calculation Sheets',
        link: kebabCase('Calculation Sheets'),
        body: 'Create and edit itineraries, which are automatically translated into worksheets that calculate the cost of group travel. Once approved, a mouse click transforms the group quotation into an operational travel file.',
        // eslint-disable-next-line react/display-name
        icon: (props) => <FontAwesomeIcon {...props} icon={['fa', 'calculator']} />,
        notDeveloped: true
    },
    {
        title: 'Schedule Automatic Process',
        link: kebabCase('Schedule Automatic Process'),
        body: "Automatic 'Report Reservation to Supplier' and 'Release Allocations' performed on a fixed schedule.",
        // eslint-disable-next-line react/display-name
        icon: (props) => <FontAwesomeIcon {...props} icon={['fa', 'clock']} />,
        notDeveloped: true
    }
];

export const columns2 = [
    {
        title: 'Passengers Flight List Report',
        link: kebabCase('Passengers Flight List Report'),
        body: 'Collectively report all self-operation flight passengers to airlines. After the report is sent, the reservation record is automatically marked as reported.',
        icon: FlightTakeoffIcon,
        notDeveloped: true
    },
    {
        title: 'Flight Reservations',
        link: kebabCase('Flight Reservations'),
        body: 'Collectively perform actions on flight reservations: change status, change class and/or flight, cancel reservation and send message.',
        // eslint-disable-next-line react/display-name
        icon: (props) => <FontAwesomeIcon {...props} icon={['fa', 'list-alt']} />,
        notDeveloped: true
    },
    {
        title: 'Change Tour Reservations',
        link: kebabCase('Change Tour Reservations'),
        body: 'Collectively perform actions on tour reservations: change status, change price level and/or tour and cancel reservation.',
        // eslint-disable-next-line react/display-name
        icon: (props) => <FontAwesomeIcon {...props} icon={['fa', 'bus']} />,
        notDeveloped: true
    },
    {
        title: 'Send Periodic Statement to Travel Agents',
        link: kebabCase('Send Periodic Statement to Travel Agents'),
        body: 'Send Periodic Statement to Travel Agents',
        // eslint-disable-next-line react/display-name
        icon: (props) => <FontAwesomeIcon {...props} icon={['fa', 'paper-plane']} />,
        notDeveloped: true
    },
    {
        title: 'View Operation Status',
        link: kebabCase('View Operation Status'),
        body: 'View status of long-running reports generated in background',
        // eslint-disable-next-line react/display-name
        icon: (props) => <FontAwesomeIcon {...props} icon={['fa', 'eye']} />,
        notDeveloped: true
    },
    {
        title: 'Mail Delivery Management',
        link: kebabCase('Mail Delivery Management'),
        body: 'View list of emails sent by the system',
        // eslint-disable-next-line react/display-name
        icon: (props) => <FontAwesomeIcon {...props} icon={['fa', 'mail-bulk']} />,
        notDeveloped: true
    }
];

const OperationsHomePage = () => {
    const classes = operationsHomePageStyles();

    return (
        <Grid>
            <Grid container className={classes.container}>
                <ColumnLinks
                    basePath="administration/operations"
                    items={columns1}
                    className={classes.columnStyle}
                />
                <ColumnLinks
                    basePath="administration/operations"
                    items={columns2}
                    className={classes.columnStyle}
                />
            </Grid>
        </Grid>
    );
};

export default OperationsHomePage;
